import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-presenters',
  templateUrl: './presenters.component.html',
  styleUrls: ['./presenters.component.scss']
})
export class PresentersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
